import { render, staticRenderFns } from "./NewComplexGroupDialog.vue?vue&type=template&id=081def7a&scoped=true"
import script from "./NewComplexGroupDialog.vue?vue&type=script&lang=js"
export * from "./NewComplexGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081def7a",
  null
  
)

export default component.exports